import { makeStyles } from "@material-ui/core";
import cx from "classnames";
import React from "react";

const useStyles = makeStyles(theme => ({
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: ({ margin }) => (margin ? theme.spacing(margin) : null),
    height: ({ fontSize }) => fontSize || 18,
    color: ({ color }) => {
      switch (color) {
        case "primary":
          return theme.palette.primary.main;
        case "seconday":
          return theme.palette.secondary.main;
        default:
          return color || "none";
      }
    },
    "&:before": {
      margin: 3,
      fontSize: ({ fontSize }) => fontSize || 18
    }
  }
}));

const Flaticon = ({ icon, fontSize, color, margin, className }) => {
  const classes = useStyles({ margin, fontSize, color });
  return <i className={cx(`flaticon-${icon}`, classes.icon, className)} />;
};

export default Flaticon;
